import { textStyle } from '@themes/mixins';
import styled from 'styled-components';

import FileUploader from '../FileUploader';
import Icon from '../Icon';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 10px 0;
`;

export const ReportedByHint = styled.div`
  ${textStyle({ color: 'textSecondary', size: '12px', textAlign: 'left' })};
  overflow-wrap: anywhere;
`;

export const RequestTypeContainer = styled.div`
  width: 100%;
`;

export const EmptyStateHint = styled.div`
  ${textStyle({ color: 'textSecondary', size: '14px', textAlign: 'left' })};
  padding: 8px 0 4px;
`;

export const StyledFileUploader = styled(FileUploader)`
  width: 100%;
  margin-top: 10px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
`;

export const NavButton = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  border-radius: 100%;
  padding: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceSecondary};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const NavButtonIcon = styled(Icon)``;
